export const countriesEcncylopediaConstants = {
  ALL_COUNTRIES_ENCYCLOPEDIA: "ALL_COUNTRIES_ENCYCLOPEDIA",
  GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID:
    "GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID",
  COUNTRIES_ENCYCLOPEDIA_PAGINATION: "COUNTRIES_ENCYCLOPEDIA_PAGINATION",
};
